import { css } from '@emotion/react';
import { Container, Box } from '@material-ui/core';
import { zLayers } from 'styles/theme';
import { desktopUp, mobileOnly, setOpacity, tabletUp } from 'styles/utils';

import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';

const WaiverContentCss = (colors: IColors) => css`
	width: 100%;
	height: auto;
	background-color: ${colors.bg_white};
	border: 1px solid #e8e8e8;
	border-top: 5px solid ${colors.tx_text_primary};
	background: ${colors.bg_white};
	box-shadow: 0 2px 22px 8px ${setOpacity(colors.tx_text_primary || '', 0.08)};
	${tabletUp} {
		padding: 50px 100px;
	}
	${desktopUp} {
		padding: 50px 208px;
	}

	${mobileOnly} {
		padding: 36px 20px;
	}
`;

const WaiverPageLayoutCss = css`
	${tabletUp} {
		padding-top: 78px;
	}

	${mobileOnly} {
		padding-top: 20px;
	}
`;
const containerCss = css`
	position: relative;
	z-index: ${zLayers.base};
`;

type Props = {
	children: React.ReactNode;
};

function WaiverPage({ children }: Props) {
	const { colors } = useColors();
	return (
		<Container maxWidth="lg">
			<div css={WaiverPageLayoutCss}>
				<div css={containerCss}>
					<Box css={WaiverContentCss(colors)}>{children}</Box>
				</div>
			</div>
		</Container>
	);
}

export default WaiverPage;
